import { flatten, isEmpty } from 'lodash';

export const checkObjectStateSelection = (
  selectedState: Record<string, string | string[]>
) => !isEmpty(flatten(Object.values(selectedState)));
